import React, { useEffect } from 'react'
import ButtonModalClose from '../../elements/ButtonModalClose'

const arrayAmPm = ['am','pm']

const ModalHoursStaff = ({ 
    handleChange, 
    values, 
    setValues, 
    _updateHoursStaff, 
    staff, 
    updateAmPm, 
    state, 
    choiceDay, 
    count, 
    _heuresMinutesOK 
}) => {

    useEffect(() => {
        staff.filter(s => s.id === state.idStaff).map(s => (
            setValues(prevValues => ({
                ...prevValues,
                hoursAMStart:s[choiceDay+'hoursAMStart'] ? s[choiceDay+'hoursAMStart'] : '0',
                minutesAMStart:s[choiceDay+'minutesAMStart'] ? s[choiceDay+'minutesAMStart'] : '0',
                hoursAMEnd:s[choiceDay+'hoursAMEnd'] ? s[choiceDay+'hoursAMEnd'] : '0',
                minutesAMEnd:s[choiceDay+'minutesAMEnd'] ? s[choiceDay+'minutesAMEnd'] : '0',
                hoursPMStart:s[choiceDay+'hoursPMStart'] ? s[choiceDay+'hoursPMStart'] : '0',
                minutesPMStart:s[choiceDay+'minutesPMStart'] ? s[choiceDay+'minutesPMStart'] : '0',
                hoursPMEnd:s[choiceDay+'hoursPMEnd'] ? s[choiceDay+'hoursPMEnd'] : '0',
                minutesPMEnd:s[choiceDay+'minutesPMEnd'] ? s[choiceDay+'minutesPMEnd'] : '0',
                amOpenDay:s[choiceDay+'amOpen'] ? true : false,
                pmOpenDay:s[choiceDay+'pmOpen'] ? true : false,
            }))
        ))
    },[count])
    
    return (
        <div className="modal fade" id="modalHoursStaff" >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{choiceDay}</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        {staff.filter(s => s.id === state.idStaff).map(s => (
                        <div key={s.id}>
                            <div>
                                {arrayAmPm.map(a => (
                                    <div key={a} className='mt-3'>
                                        <div className='row h5 text-center'>
                                            <div className='col'>
                                                <div className='py-2'>{a === 'am' ? 'matin' : 'soir'}</div>
                                            </div>
                                            <div className='col'>
                                                <div
                                                    className={s[choiceDay+a+'Open'] === true ? 'bg-success py-2 rounded' : 'py-2 rounded'}
                                                    style={{ cursor:'pointer' }}
                                                    onClick={() => updateAmPm([choiceDay+a+'Open'], true)}
                                                >OUVERT</div>
                                            </div>
                                            <div className='col'>
                                                <div
                                                    className={s[choiceDay+a+'Open'] === true ? 'py-2 rounded' : 'bg-danger py-2 rounded'}
                                                    style={{ cursor:'pointer' }}
                                                    onClick={() => updateAmPm([choiceDay+a+'Open'], false)}
                                                >FERMER</div>
                                            </div>
                                        </div>
                                        {s[choiceDay+a+'Open'] === true && 
                                        <>
                                            <div className='text-center'>début</div>
                                            <div className='row'>
                                                <div className='col'>
                                                    <input 
                                                        type="number" 
                                                        className="form-control border-0 rounded-pill shadow p-2 ms-2" 
                                                        placeholder="heures" 
                                                        name={a === 'am' ? 'hoursAMStart' : 'hoursPMStart'}
                                                        onChange={ handleChange} 
                                                        value={a === 'am' ? values.hoursAMStart : values.hoursPMStart} 
                                                    />
                                                </div>
                                                <div className='col'>
                                                    <input 
                                                        type="number" 
                                                        className="form-control border-0 rounded-pill shadow p-2 ms-2" 
                                                        placeholder="minutes"
                                                        name={a === 'am' ? 'minutesAMStart' : 'minutesPMStart'} 
                                                        onChange={handleChange} 
                                                        value={a === 'am' ? values.minutesAMStart : values.minutesPMStart} 
                                                    />
                                                </div>
                                            </div>
                                            <div className='text-center'>fin</div>
                                            <div className='row'>
                                                <div className='col'>
                                                    <input 
                                                        type="number" 
                                                        className="form-control border-0 rounded-pill shadow p-2 ms-2" 
                                                        placeholder="heures" 
                                                        name={a === 'am' ? 'hoursAMEnd' : 'hoursPMEnd'} 
                                                        onChange={handleChange} 
                                                        value={a === 'am' ? values.hoursAMEnd : values.hoursPMEnd} 
                                                    />
                                                </div>
                                                <div className='col'>
                                                    <input 
                                                        type="number" 
                                                        className="form-control border-0 rounded-pill shadow p-2 ms-2" 
                                                        placeholder="minutes"
                                                        name={a === 'am' ? 'minutesAMEnd' : 'minutesPMEnd'} 
                                                        onChange={handleChange} 
                                                        value={a === 'am' ? values.minutesAMEnd : values.minutesPMEnd} 
                                                    />
                                                </div>
                                            </div>
                                        </>
                                        }
                                    <hr/>
                                    </div>
                                ))}
                            </div>
                            <div className='text-center text-danger'>{_heuresMinutesOK()}</div>
                            <ButtonModalClose
                                title='Enregistrer'
                                onClick={_updateHoursStaff}
                                disabled={_heuresMinutesOK() != null ? true : false}
                            />
                        </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalHoursStaff

/*

*/